import { Validateable } from "@models/interfaces";

export class StockToggleSlider extends Validateable {
	public contracts: boolean = false;
	public documents: boolean = false;
	public investRisk: boolean = false;

	public showInvestRisk: boolean = false;

	public getAllEnabled(): boolean {
		return this.documentsEnabled() && this.investRiskAccepted();
	}

	public wiggleAll(): void {
		if (!this.documents) {
			this.wiggle("documents");
		}
		if (!this.investRisk) {
			this.wiggle("investRisk");
		}
	}

	public disableSliders(): void {
		this.documents = false;
		this.investRisk = false;
	}

	public documentsEnabled(): boolean {
		return this.documents;
	}

	public investRiskAccepted(): boolean {
		if (this.showInvestRisk) {
			return this.investRisk;
		}
		return true;
	}
}
